import React from 'react';
import i18n from 'i18next';
import Section from './section';
import classNames from 'classnames';
import { trackFootfallEvent, trackFootfallEventWithHrefDelay } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import config from 'config/config';

const getLinks = () => [
  {
    id: 'conditions',
    title: i18n.t('Common condition areas'),
    links: [
      { id: 'cancer', name: i18n.t('Cancer') },
      { id: 'cardiovascular-disease', name: i18n.t('Cardiovascular disease') },
      { id: 'digestive-and-liver-conditions', name: i18n.t('Digestive and liver conditions') },
      { id: 'healthy-living', name: i18n.t('Healthy living') },
      { id: 'kidney-and-urinary-conditions', name: i18n.t('Kidney and urinary conditions') },
      { id: 'lung-conditions', name: i18n.t('Lung conditions') },
      { id: 'mental-health', name: i18n.t('Mental health') },
      { id: 'muscles-bones-and-joints', name: i18n.t('Muscles, bones and joints') },
      { id: 'neurological-disorders', name: i18n.t('Neurological disorders') },
      { id: 'womens-health', name: i18n.t('Womens health') },
      { id: 'conditions', name: i18n.t('See all'), isMoreLink: true  },
    ],
  },
  {
    id: 'treatments',
    title: i18n.t('Common treatments'),
    links: [
      { id: 'amitriptyline', name: i18n.t('Amitriptyline') },
      { id: 'avastin', name: i18n.t('Avastin') },
      { id: 'azathioprine', name: i18n.t('Azathioprine') },
      { id: 'azilect', name: i18n.t('Azilect') },
      { id: 'bisoprolol', name: i18n.t('Bisoprolol') },
      { id: 'cimzia', name: i18n.t('Cimzia') },
      { id: 'citalopram', name: i18n.t('Citalopgram') },
      { id: 'enbrel', name: i18n.t('Enbrel') },
      { id: 'humira', name: i18n.t('Humira') },
      { id: 'pramipexole', name: i18n.t('Pramipexole') },
      { id: 'prednisolone', name: i18n.t('Prednisolone') },
      { id: 'hydroxychloroquine', name: i18n.t('Hydroxychloroquine') },
      { id: 'leflunomide', name: i18n.t('Leflunomide') },
      { id: 'lyrica', name: i18n.t('Lyrica') },
      { id: 'metformin', name: i18n.t('Metformin') },
      { id: 'methotrexate', name: i18n.t('Methotrexate') },
      { id: 'naproxen', name: i18n.t('Naproxen') },
      { id: 'plaquenil', name: i18n.t('Plaquenil') },
      { id: 'pregabalin', name: i18n.t('Pregabalin') },
      { id: 'rituximab', name: i18n.t('Rituximab') },
      { id: 'rivaroxaban', name: i18n.t('Rivaroxaban') },
      { id: 'sertraline', name: i18n.t('Sertraline') },
      { id: 'tramadol', name: i18n.t('Tramadol') },
      { id: 'warfarin', name: i18n.t('Warfarin') },
      { id: 'treatments', name: i18n.t('See all'), isMoreLink: true  },
    ],
  },
];

class DiscoverSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: true,
    };
  }

  onToggleVisible = (e) => {
    e.preventDefault();
    trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: { section: 'discover-seemore' }, clickType: 'visitor-homepage' });
    this.setState({ isCollapsed: !this.state.isCollapsed });
  }

  renderLink({ id, name, isMoreLink }) {
    const className = classNames({
      'home__link-more': isMoreLink,
    });
    return (
      <a
        className={className}
        href={`/${id}`}
        key={`link-${id}`}
        onClick={e => {
          e.preventDefault();
          trackFootfallEventWithHrefDelay(`/${id}`, footfallEventTypes.CLICKED, {
            clickMetadata: { section: isMoreLink ? 'tags-seeall' : 'tag', type: id },
            clickType: 'visitor-homepage',
          });
        }}
      >
        {name}
        {' '}
        {isMoreLink && <span className="icon icon-forwards-arrow" />}
      </a>
    );
  }

  renderLinks() {
    return (
      getLinks().map(linkSection => {
        const className = classNames({
          'home__link-section': true,
          'home__link-section--large': linkSection.links.length > 14,
        });
        return (
          <div key={`section-${linkSection.id}`}>
            <h4>{linkSection.title}</h4>
            <div className={className}>
              {linkSection.links.map(this.renderLink)}
            </div>
          </div>
        );
      })
    );
  }

  render() {
    const linksClassName = classNames({
      'home__common-links': true,
      'home__common-links--open': !this.state.isCollapsed,
     });
     const toggleClassName = classNames({
      'icon': true,
      'icon-down-open-1': this.state.isCollapsed,
      'icon-up-open-1': !this.state.isCollapsed,
     });
    return (
      <Section>
        <div className="home__section-content--split">
          <div className="hidden-xs">
            <img alt="Home 2" className="home__image" src={`${config.cdn.static}img/home/home-2.jpg`} />
          </div>
          <div className="home__section-side">
            <h2>{i18n.t('Discover your health')}</h2>
            <p>{i18n.t("We are leaders in support and information in over 200 different areas of health. Whatever you're looking for, we've got you covered.")}</p>
            <p>
              <a href="#" onClick={this.onToggleVisible}>
                {this.state.isCollapsed ? i18n.t('See more') : i18n.t('See less')}
                {' '}
                <span className={toggleClassName} />
              </a>
            </p>
          </div>
        </div>
        <div className={linksClassName}>
          {this.renderLinks()}
        </div>
        <div className="visible-xs">
          <img alt="Home 2" className="home__image" src={`${config.cdn.static}img/home/home-2.jpg`} />
        </div>
      </Section>
    );
  }
}

export default DiscoverSection;



// WEBPACK FOOTER //
// ./src/modules/home/components/discoverSection.js